export default __webpack_public_path__ + "assets/img/new_favicon.46e948f.png";